import { ofType } from "redux-observable";
import { filter, mapTo, switchMap } from "rxjs/operators";
import { actionBaseInfoAddBuilding } from "../../../info/base/actionBaseInfo";
import { TypeActionBuildings } from "../actionBuildings";
export var epicBuildingsCancelMove = function (action$) {
    return action$.pipe(filter(function (action) { return action.type === TypeActionBuildings.StartMove; }), switchMap(function (action) {
        return action$.pipe(ofType(TypeActionBuildings.CancelMove), mapTo(actionBaseInfoAddBuilding(action.building.proto)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsCancelMove.ts
// module id = 2048
// module chunks = 3